import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrokerInterface } from 'app/module/broker-interface';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root'
})
export class BrokerService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}
	constructor(private http: HttpClient) { }

	public get(): Observable<BrokerInterface> {
		return this.http.get<BrokerInterface>(`${this.url}broker`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
